export default {
  title: 'Kanta-asiakasohjelma',
};
